function VeritracksAsociation(aCorrelation)
{
    this.Identifier = "";
    this.Description = "";
    if (aCorrelation) {
        this.Identifier = aCorrelation.PointGroupingId.toString();
        this.Description = getConnectionReason(aCorrelation, GetEnrollee(aCorrelation.Id), GetEnrollee(aCorrelation.MatchEnrolleeId));
    }
}
if (typeof exports !== 'undefined') {
    module.exports = VeritracksAsociation;
}